export const generateShortcode = (name) =>
  (name || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "")
    .slice(0, 32);

export const buildGatheringPayload = (formData, hostID) => {
  const normalizedShortcode = String(formData.shortcode || "").trim();
  const shortcode = normalizedShortcode || generateShortcode(formData.gatheringName);

  return {
    ...formData,
    shortcode,
    hostID,
  };
};
